import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from "./home/home.component";
import {CantactComponent} from "./cantact/cantact.component";
import {ServicesComponent} from "./services/services.component";
import {PricingComponent} from "./pricing/pricing.component";
import {AboutComponent} from "./about/about.component";


const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' }, // Default route
  { path: 'home', component: HomeComponent },
  { path: 'contact', component: CantactComponent },
  { path: 'service', component: ServicesComponent },
  { path: 'pricing', component: PricingComponent },
  { path: 'about', component: AboutComponent },
  { path: '**', redirectTo: 'home' } // Wildcard for unknown routes
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
